import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { MapContainer, TileLayer, Marker, Polygon } from 'react-leaflet';
import L from 'leaflet';
import ReactDOMServer from 'react-dom/server';
import { ReactComponent as OakSvg } from '../../../../assets/icons/oak.svg';
import { ReactComponent as PoplarSvg } from '../../../../assets/icons/poplar.svg';
import { ReactComponent as ChestnutSvg } from '../../../../assets/icons/chestnut.svg';
import { ReactComponent as SolarSvg } from '../../../../assets/icons/solar.svg';
import { ReactComponent as WindSvg } from '../../../../assets/icons/wind.svg';
import StackedLineChart from 'components/common/chart/StackedLineChart';
import EstimatedCost from '../summary-report/EstimatedCost';
import SolarPanel from './SolarPanel';
import TreePlanting from './TreePlanting';
import WindTurbine from './WindTurbine';
import ExportToXLSX from 'components/common/export-file/ExportToXLSX';

const ReportingModule = () => {
  const allMarkerPoints = [
    //solar panel
    {
      id: '0_4_1743990935678',
      lat: 51.89764541109226,
      lng: -8.49457577263408,
      itemType: 4
    },
    // wind turbine
    {
      id: '1_5_1743991032736',
      lat: 51.897502729236685,
      lng: -8.495254424917702,
      itemType: 5
    },
    {
      id: '0_5_1743991032735',
      lat: 51.89733540438229,
      lng: -8.495052706567726,
      itemType: 5
    },
    //oak tree
    {
      id: '0_1_1743991124466',
      lat: 51.89712190386952,
      lng: -8.496002797740873,
      itemType: 1
    },
    {
      id: '1_1_1743991124467',
      lat: 51.89712190386952,
      lng: -8.496237128991059,
      itemType: 1
    },
    {
      id: '2_1_1743991124467',
      lat: 51.8972925733626,
      lng: -8.496002797740873,
      itemType: 1
    },
    {
      id: '3_1_1743991124467',
      lat: 51.8972925733626,
      lng: -8.496237128991059,
      itemType: 1
    },
    {
      id: '4_1_1743991124468',
      lat: 51.8972925733626,
      lng: -8.496471460241244,
      itemType: 1
    },
    {
      id: '5_1_1743991124468',
      lat: 51.897463242855686,
      lng: -8.496237128991059,
      itemType: 1
    },
    {
      id: '6_1_1743991124468',
      lat: 51.897463242855686,
      lng: -8.496471460241244,
      itemType: 1
    }
  ];

  const selectedLandParcels = [
    {
      id: 1743990813635,
      parcelId: 1743990813635,
      coordinates: [
        [51.89749460622033, -8.496664367682373],
        [51.897590626730455, -8.496197202598715],
        [51.89711052212764, -8.49584817121436],
        [51.89699132294852, -8.496342184866046],
        [51.89749460622033, -8.496664367682373]
      ],
      area: 0.33312901026514796,
      isDrawn: true,
      vertices: [
        {
          lat: 51.89749460622033,
          lng: -8.496664367682373,
          key: 1743990813635
        },
        {
          lat: 51.897590626730455,
          lng: -8.496197202598715,
          key: 1743990813635
        },
        {
          lat: 51.89711052212764,
          lng: -8.49584817121436,
          key: 1743990813635
        },
        {
          lat: 51.89699132294852,
          lng: -8.496342184866046,
          key: 1743990813635
        }
      ],
      xMin: -8.49584817121436,
      xMax: -8.496664367682373,
      yMin: 51.89699132294852,
      yMax: 51.897590626730455
    },
    {
      id: 1743993575355,
      parcelId: 1743993575355,
      coordinates: [
        [51.897599480764704, -8.495433479988803],
        [51.89765907958708, -8.495143515454119],
        [51.8973114186754, -8.494896508628266],
        [51.89724188617025, -8.495148885167714],
        [51.897599480764704, -8.495433479988803]
      ],
      area: 0.13791949151716498,
      isDrawn: true,
      vertices: [
        {
          lat: 51.897599480764704,
          lng: -8.495433479988803,
          key: 1743993575355
        },
        {
          lat: 51.89765907958708,
          lng: -8.495143515454119,
          key: 1743993575355
        },
        {
          lat: 51.8973114186754,
          lng: -8.494896508628266,
          key: 1743993575355
        },
        {
          lat: 51.89724188617025,
          lng: -8.495148885167714,
          key: 1743993575355
        }
      ],
      xMin: -8.494896508628266,
      xMax: -8.495433479988803,
      yMin: 51.89724188617025,
      yMax: 51.89765907958708
    },
    {
      id: 1743993693631,
      parcelId: 1743993693631,
      coordinates: [
        [51.89753657164351, -8.494756896074529],
        [51.89771536812381, -8.494756896074529],
        [51.89771536812381, -8.494381016122144],
        [51.89753657164351, -8.494381016122144],
        [51.89753657164351, -8.494756896074529]
      ],
      area: 0.0821840390919244,
      isDrawn: true,
      vertices: [
        {
          lat: 51.89753657164351,
          lng: -8.494756896074529,
          key: 1743993693631
        },
        {
          lat: 51.89771536812381,
          lng: -8.494756896074529,
          key: 1743993693631
        },
        {
          lat: 51.89771536812381,
          lng: -8.494381016122144,
          key: 1743993693631
        },
        {
          lat: 51.89753657164351,
          lng: -8.494381016122144,
          key: 1743993693631
        }
      ],
      xMin: -8.494381016122144,
      xMax: -8.494756896074529,
      yMin: 51.89753657164351,
      yMax: 51.89771536812381
    }
  ];

  const getIcon = itemType => {
    switch (itemType) {
      case 1:
        return new L.DivIcon({
          html: ReactDOMServer.renderToString(
            <OakSvg className="land-dev-tree-icon" />
          ),
          className: 'oak'
        });
      case 2:
        return new L.DivIcon({
          html: ReactDOMServer.renderToString(
            <PoplarSvg className="land-dev-tree-icon" />
          ),
          className: 'poplar'
        });
      case 3:
        return new L.DivIcon({
          html: ReactDOMServer.renderToString(
            <ChestnutSvg className="land-dev-tree-icon" />
          ),
          className: 'chestnut'
        });
      case 4:
        return new L.DivIcon({
          html: ReactDOMServer.renderToString(
            <SolarSvg className="land-dev-tree-icon" />
          ),
          className: 'solar'
        });

      default:
        return new L.DivIcon({
          html: ReactDOMServer.renderToString(
            <WindSvg className="land-dev-tree-icon" />
          ),
          className: 'wind'
        });
    }
  };

  const currentYear = new Date().getFullYear();
  const nextTenYears = Array.from(
    { length: 10 },
    (_, index) => currentYear + index * 3
  );

  const plantingDataSource = [
    {
      id: 1743994398971,
      name: 'Oak',
      numberOfItems: 7,
      itemType: 0,
      carbonOffset: [
        0, 10.5, 101.5, 367.5, 745.5, 1179.5, 1620.5, 2054.5, 2432.5, 2747.5,
        3000
      ]
    },
    {
      id: 1743994398972,
      name: 'Wind Turbine',
      numberOfItems: 2,
      itemType: 3,
      carbonOffset: [7665, 7665, 7665, 7665, 7665, 7665, 7665, 7665, 7665, 7665]
    },
    {
      id: 1743994398973,
      name: 'Solar Panel',
      numberOfItems: 1,
      itemType: 4,
      carbonOffset: [6.5, 6.5, 6.5, 6.5, 6.5, 6.5, 6.5, 6.5, 6.5, 6.5]
    }
  ];
  const Co2DataSource = plantingDataSource.map(item => ({
    name: item.name,
    type: 'line',
    symbolSize: 10,
    symbol: 'circle',
    data: item.carbonOffset
  }));

  const carbonStat = {
    title: 'Estimated Carbon Offset',
    value: 233.2,
    decimal: false,
    suffix: ' tCO2',
    valueClassName: 'text-warning',
    badgeBg: 'warning',
    link: 'paths.customers',
    linkText: 'See all'
  };

  const data = {
    treePlanting: [
      [
        'Tree Species',
        'Location',
        'Planting Date',
        'Expected Growth Rate (m/year)',
        'Expected Carbon Sequestration (kg/year)',
        'Soil Quality',
        'Water Availability',
        'Maintenance Plan',
        'Biodiversity Contribution',
        'Monitoring Frequency'
      ],
      [
        'Mangrove',
        'Coastal Vietnam',
        '2025-01-10',
        1.2,
        50,
        'High',
        'High',
        'Monthly irrigation and trimming',
        'High - supports marine ecosystems',
        'Quarterly'
      ],
      [
        'Acacia',
        'Central Highlands',
        '2024-11-20',
        1.5,
        35,
        'Moderate',
        'Medium',
        'Bi-annual pruning',
        'Moderate - soil enrichment',
        'Annually'
      ],
      [
        'Teak',
        'Northern Mountains',
        '2025-02-15',
        2.0,
        60,
        'Good',
        'Low',
        'Fertilizing every 6 months',
        'Moderate - shade and fauna shelter',
        'Semi-Annually'
      ]
    ],
    windTurbine: [
      ['Wind Turbine Carbon Offset Evaluation Report'],
      ['Site Information'],
      ['Location', 'Coastal Region'],
      ['Coordinates', '52.1, 4.3'],
      ['Wind Resource Class', 'Class III – Moderate'],
      [],
      ['Technical Specifications'],
      ['Turbine Model', 'Vestas V112-3.0 MW'],
      ['Rated Capacity', '3.0 MW'],
      ['Hub Height', '80 m'],
      ['Rotor Diameter', '112 m'],
      ['Number of Units', '5'],
      [],
      ['Energy Output'],
      ['Capacity Factor', '35%'],
      ['Annual Energy Production (AEP)', '45,000 MWh/year'],
      ['Grid Efficiency Losses', '5%'],
      [],
      ['Carbon Offset Potential'],
      ['Emission Factor for Grid Electricity', '0.45 kg CO₂/kWh'],
      ['Total Carbon Offset per Year', '20,250 tCO₂/year'],
      [],
      ['Project Lifespan'],
      ['Expected Operation Period', '20–25 years'],
      ['Total Lifetime Offset', '405,000–506,250 tCO₂'],
      [],
      ['Other Environmental Considerations'],
      ['Bird/Bat Impact', 'Low'],
      ['Noise & Visual Impact', 'Moderate'],
      ['Land Use Change', 'Minimal'],
      [],
      ['Certifications & Methodologies'],
      ['Standard', 'Gold Standard'],
      ['MRV Plan', 'Annual Monitoring']
    ],
    solarPanel: [
      ['Solar Panel Carbon Offset Evaluation Report'],
      ['Site Information'],
      ['Location', 'Utility-Scale Desert Site'],
      ['Coordinates', '35.6, -115.2'],
      ['Solar Irradiation Level', '5.5 kWh/m²/day'],
      [],
      ['Technical Specifications'],
      ['Panel Type', 'Mono-crystalline'],
      ['System Size', '1 MWp'],
      ['Inverter Efficiency', '96%'],
      ['Tilt & Orientation', 'South-facing, 25°'],
      [],
      ['Energy Output'],
      ['Annual Energy Production (AEP)', '1,600 MWh/year'],
      ['Degradation Factor', '0.5% per year'],
      ['Grid Losses', '3%'],
      [],
      ['Carbon Offset Potential'],
      ['Emission Factor for Grid Electricity', '0.45 kg CO₂/kWh'],
      ['Total Carbon Offset per Year', '720 tCO₂/year'],
      [],
      ['Project Lifespan'],
      ['Expected Operation Period', '25–30 years'],
      ['Total Lifetime Offset', '18,000–21,000 tCO₂'],
      [],
      ['Other Environmental Considerations'],
      ['Panel Recycling', 'Planned'],
      ['Land Use', 'Low'],
      ['Heat Island Mitigation', 'Positive'],
      [],
      ['Certifications & Methodologies'],
      ['Standard', 'Verra'],
      ['MRV Plan', 'Annual Reporting']
    ]
  };

  return (
    <>
      <Card>
        <Card.Body>
          <MapContainer
            style={{ height: 300 }}
            className="w-100 mb-1"
            center={[51.89745818425509, -8.495224210493426]}
            zoom={18}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            {selectedLandParcels &&
              selectedLandParcels.map(parcel => {
                return (
                  <Polygon
                    key={parcel.id}
                    pathOptions={{ color: 'blue' }}
                    positions={parcel.coordinates}
                    weight={1}
                  ></Polygon>
                );
              })}
            {allMarkerPoints.map(marker => {
              return (
                <Marker
                  key={marker.id}
                  position={[marker.lat, marker.lng]}
                  icon={getIcon(marker.itemType)}
                ></Marker>
              );
            })}
          </MapContainer>
          <h6>Project Name: ABC</h6>
          <label>Description: </label>
          <br />
          <label>Location: Cork, Ireland</label>
          <br />
          <label>Estimated Size: 0.54 (ha)</label>
          <div style={{ float: 'right' }}>
            <ExportToXLSX
              data={data}
              fileName="Carbon_Offset_Evaluation_Report"
            ></ExportToXLSX>
          </div>
        </Card.Body>
      </Card>

      <Row className="mt-1 g-3 mb-3 row-equal-height">
        <Col md={4} lg={4} xl={4} xxl={4}>
          <Card>
            <Card.Header className="d-flex flex-column justify-content-center align-items-center">
              <h4>Tree Planting</h4>
            </Card.Header>
            <Card.Body>
              <TreePlanting />
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} lg={4} xl={4} xxl={4}>
          <Card>
            <Card.Header className="d-flex flex-column justify-content-center align-items-center">
              <h4>Wind Turbines</h4>
            </Card.Header>
            <Card.Body>
              <WindTurbine />
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} lg={4} xl={4} xxl={4}>
          <Card>
            <Card.Header className="d-flex flex-column justify-content-center align-items-center">
              <h4>Solar Panels</h4>
            </Card.Header>
            <Card.Body>
              <SolarPanel />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Card>
        <Card.Body>
          <EstimatedCost stat={carbonStat}></EstimatedCost>
          <br />
          <StackedLineChart
            xAxisData={nextTenYears}
            seriesData={Co2DataSource}
          ></StackedLineChart>
        </Card.Body>
      </Card>
    </>
  );
};

export default ReportingModule;
